<div class="kpi-grid">
  <ng-content></ng-content>
</div>
